<dx-date-box #dateBox
  [value]="value"
  (onValueChanged)="onDateSelected($event)"
  [openOnFieldClick]="true"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [displayFormat]="getDisplayFormat()"
  [disabledDates]="isDateDisabled">
  <dxo-calendar-options
    [zoomLevel]="getSelectedLevel()"
    [maxZoomLevel]="getSelectedLevel()">
  </dxo-calendar-options>
</dx-date-box>
